<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { formatDate } from 'utils/dateutils';
  import { getAffPaymentAppList } from 'api/affSendingBilling/application/affPaymentApplication';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import AffPaymentAppBaseForm from '@/views/billing/forms/AffPaymentAppBaseForm.vue';
  import { userInfoMixin } from '@/mixins/userInfoMixin';
  import AttachmentPopoverTable from '@/components/common/AttachmentPopoverTable.vue';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  export default {
    name: 'AffPaymentApp',
    components: {
      AttachmentPopoverTable: AttachmentPopoverTable,
      AffPaymentAppBaseForm,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, userInfoMixin, financeInfoMixins],
    data() {
      return {
        dialogVisible: false,
        dialogType: 'new',
        paymentType: 'POST_PAID',
        total: 0,
        listLoading: false,
        refreshDownloadUrlLoading: false,
        dataList: [],
        auditStatus: null,
        financeAuditStatus: null,
        filter: {
          page: 1,
          pageSize: 10,
          affCompanyPlatform: null,
          affPaymentAppNumber: null,
          affEntity: null,
          hyperTapEntity: null,
          auditStatus: null,
          paymentStatus: null,
          currency: null,
          paymentType: null,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },

      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleCreate(paymentType) {
        this.dialogType = 'new';
        this.paymentType = paymentType;
        this.dialogVisible = true;
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAffPaymentAppList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
              this.$nextTick(() => {
                this.$refs.tableRef.doLayout();
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      handleApprovalForm(dialogType, auditStatus) {
        this.dialogType = dialogType;
        this.auditStatus = auditStatus;
        this.dialogVisible = true;
      },
      /**
       * 控制 Payment Status 显示 <br>
       * @param row
       */
      showPaymentStatus(row) {
        const temp = this.affPaymentAppOperationPaymentStatusList.concat(
          this.affPrePaidPaymentAppPaymentStatusList
        );
        return (
          this.getEnumLabel(temp, row.paymentStatus) +
          ' (' +
          this.getEnumLabel(this.affPaymentAppAuditStatusList, row.auditStatus) +
          ')'
        );
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Aff Payment Management'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Application Number">
          <el-input v-model="filter.affPaymentAppNumber" />
        </el-form-item>
        <el-form-item label="Aff Company Platform">
          <el-select
            v-model="filter.affCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(filter.affCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Entity">
          <el-select v-model="filter.affEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.hyperTapEntity"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.companyEntity"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Payment Status">
          <el-select
            v-model="filter.paymentStatus"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in affPaymentAppOperationPaymentStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Currency">
          <el-select v-model="filter.currency" filterable clearable placeholder="please select">
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Payment Type">
          <el-select v-model="filter.paymentType" filterable clearable placeholder="please select">
            <el-option
              v-for="item in affPaymentTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Application Status">
          <el-select v-model="filter.auditStatus" filterable clearable placeholder="please select">
            <el-option
              v-for="item in affPaymentAppAuditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
      <el-button
        v-if="isAffAm()"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate('POST_PAID')"
        >Create Post Paid Payment</el-button
      >
      <el-button
        v-if="isAffAm()"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate('PRE_PAID')"
        >Create Pre Paid Payment</el-button
      >
      <el-button v-if="isAffAm()" type="success" @click="handleApprovalForm('status', 'APPROVED')"
        >Approve</el-button
      >
      <el-button v-if="isAffAm()" type="warning" @click="handleApprovalForm('status', 'REJECTED')"
        >UnApprove</el-button
      >
      <el-button
        v-if="isAffAm()"
        type="primary"
        @click="handleApprovalForm('status', 'SENT_FINANCE')"
        >Send</el-button
      >
      <el-button
        v-if="isFinance()"
        type="primary"
        @click="handleApprovalForm('status', 'FINANCE_PAID')"
        >Pay</el-button
      >
      <el-button
        v-if="isFinance()"
        type="warning"
        @click="handleApprovalForm('status', 'FINANCE_REJECTED')"
        >Reject</el-button
      >
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        stripe
        border
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          align="center"
          width="120"
          fixed="left"
          key="recordStartDate"
        />
        <el-table-column
          label="Aff Payment Application Number"
          prop="affPaymentAppNumber"
          align="center"
          width="250"
          key="affPaymentAppNumber"
        />
        <el-table-column
          label="Aff Company Platform"
          prop="affCompanyPlatform"
          align="center"
          width="170"
          key="companyPlatform"
        />
        <el-table-column
          label="Aff Entity"
          prop="affEntity"
          align="center"
          width="170"
          key="affEntity"
        />
        <el-table-column
          label="Payment Type"
          prop="paymentType"
          align="center"
          width="140"
          key="paymentType"
        >
          <template #default="scope">
            {{ getPaymentType(scope.row.paymentType) }}
          </template>
        </el-table-column>
        <el-table-column label="Aff Bank Account" align="center" width="170">
          <template #default="scope">
            <el-popover trigger="hover">
              <el-descriptions :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Name
                  </template>
                  {{ scope.row.bankInfo.bankName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Address
                  </template>
                  {{ scope.row.bankInfo.bankAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Number
                  </template>
                  {{ scope.row.bankInfo.bankAccountNumber }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Name
                  </template>
                  {{ scope.row.bankInfo.bankAccountName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Swift Code
                  </template>
                  {{ scope.row.bankInfo.swiftCode }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Branch Code
                  </template>
                  {{ scope.row.bankInfo.branchCode }}
                </el-descriptions-item>
              </el-descriptions>
              <el-link type="primary" slot="reference">{{
                scope.row.bankInfo.bankAccountName
              }}</el-link>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Revenue"
          prop="affRevenue"
          align="center"
          key="affRevenue"
          width="140"
          sortable="custom"
        />
        <el-table-column
          label="Aff Confirmed Amount"
          prop="affConfirmedAmount"
          align="center"
          key="affConfirmedAmount"
          width="200"
          sortable="custom"
        />
        <el-table-column
          label="Aff Confirmed Amount Rate"
          prop="affConfirmedAmountRate"
          align="center"
          key="affConfirmedAmountRate"
          width="230"
          sortable="custom"
        />
        <el-table-column
          label="Actual Amount"
          prop="actualAmount"
          align="center"
          key="actualAmount"
          width="210"
          sortable="custom"
        />
        <el-table-column
          label="Aff Hedge Amount"
          prop="affHedgeAmount"
          align="center"
          key="affHedgeAmount"
          width="200"
          sortable="custom"
        />
        <el-table-column label="Currency" prop="currency" align="center" key="currency" width="120">
          <template #default="scope">
            {{ getEnumLabel(currencyList, scope.row.currency) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Apply Payment Amount"
          prop="applyPaymentAmount"
          align="center"
          key="applyPaymentAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Finance Payment Amount"
          prop="financePaymentAmount"
          align="center"
          key="financePaymentAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          key="hyperTapEntity"
          width="160"
        >
          <template #default="scope">
            {{ getHyperTapCompanyAlias(scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount Rate"
          prop="actualAmountRate"
          align="center"
          width="180"
          key="actualAmountRate"
        />
        <el-table-column
          label="Payment Time"
          prop="paymentTime"
          align="center"
          key="paymentTime"
          width="160"
        />

        <el-table-column label="Attachments" align="center" width="170">
          <template #default="scope">
            <attachment-popover-table
              @refresh-list="handleSearch"
              :file-list="scope.row.fileList"
              :file-business-type="'INVOICE'"
            />
          </template>
        </el-table-column>

        <el-table-column label="Receipt Attachments" align="center" width="170">
          <template #default="scope">
            <attachment-popover-table
              @refresh-list="handleSearch"
              :file-list="scope.row.fileList"
              :file-business-type="'BANK_SLIP'"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="Aff Payment Application Status"
          prop="auditStatus"
          align="center"
          key="auditStatus"
          width="240"
          fixed="right"
        >
          <template #default="scope">
            {{ getPaymentAppAuditStatus(scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Payment Status"
          prop="paymentStatus"
          align="center"
          key="paymentStatus"
          width="230"
        >
          <template #default="scope">
            {{ showPaymentStatus(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Remark"
          prop="remark"
          :show-overflow-tooltip="true"
          align="center"
          key="remark"
          width="250"
        />
        <el-table-column
          label="Operation Audit Remark"
          prop="operationAuditRemark"
          :show-overflow-tooltip="true"
          align="center"
          key="operationAuditRemark"
          width="250"
        />
        <el-table-column
          label="Finance Audit Remark"
          prop="financeAuditRemark"
          :show-overflow-tooltip="true"
          align="center"
          key="financeAuditRemark"
          width="250"
        />
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
    <template #dialog>
      <aff-payment-app-base-form
        :dialogVisible.sync="dialogVisible"
        :dialog-type="dialogType"
        :auditStatus.sync="auditStatus"
        :payment-type.sync="paymentType"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
